import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-sales-preview',
  templateUrl: './sales-preview.component.html'
})
export class SalesPreviewComponent {
  @Input() salesDescription = '';
  @Input() numberOfSales = 0;

}
